<template>
  <section class="container max-w-7xl h-auto items-center mx-auto mt-5 py-12 px-5">
    <h2 class="w-full py-5 font-cursive text-3xl font-extrabold tracking-tight md:text-4xl lg:text-5xl">
      <span class="text-secondaire">Nouveaux</span>&nbsp;<span class="text-primaire">adoptés</span>&nbsp;🐱
    </h2>

    <p class="text-lg text-gray-500 lg:text-xl md:max-w-full font-serif">
      Un immense merci à tous ceux qui ont choisi d’adopter un chat ou un chaton de notre groupe, leur offrant ainsi
      une seconde chance. Découvrez les
      <router-link
        to="/nos-adoptes"
        class="text-primaire underline hover:no-underline hover:text-navigation"
      >
        photos
      </router-link>
      de nos adorables petits chanceux, qui ont maintenant trouvé leur foyer aimant.
    </p>

    <div class="h-auto p-5 border-b-2 border-primaire shadow-lg">
      <div class="images-galerie columns-2 gap-4 lg:columns-3 mt-5">
        <router-link
          v-for="chat in chatsAdoptes"
          :key="chat.nom"
          class="galerie-item"
          to="/nos-adoptes"
          :title="chat.nom"
          :aria-label="`Voir ${chat.nom}, ${chat.sexe}`"
        >
          <img
            :src="chat.src"
            :alt="`${chat.nom}, ${chat.sexe} adopté${chat.sexe === 'femelle' ? 'e' : ''}`"
            loading="lazy"
            decoding="async"
          />
        </router-link>
      </div>
    </div>
  </section>
</template>

<script setup>
import louna from '@/assets/images/chats_adoptes/01__femelle__2123__louna.webp'
import coeurDePirateJr from '@/assets/images/chats_adoptes/02__male__2050__coeurdepiratejr.webp'
import irene from '@/assets/images/chats_adoptes/03__femelle__2109__irene.webp'
import alice from '@/assets/images/chats_adoptes/04__femelle__2074__alice.webp'
import corail from '@/assets/images/chats_adoptes/05__male__1824__corail.webp'
import mrMarbles from '@/assets/images/chats_adoptes/06__male__2086__mr_marbles.webp'
import petiteFleur from '@/assets/images/chats_adoptes/07__femelle__2095__petite_fleur.webp'
import crevette from '@/assets/images/chats_adoptes/08__femellle__2087__crevette.webp'

const chatsAdoptes = [
  { nom: 'Louna', sexe: 'femelle', src: louna },
  { nom: 'CoeurDePirateJr', sexe: 'mâle', src: coeurDePirateJr },
  { nom: 'Irène', sexe: 'femelle', src: irene },
  { nom: 'Alice', sexe: 'femelle', src: alice },
  { nom: 'Corail', sexe: 'mâle', src: corail },
  { nom: 'MrMarbles', sexe: 'mâle', src: mrMarbles },
  { nom: 'PetiteFleur', sexe: 'femelle', src: petiteFleur },
  { nom: 'Crevette', sexe: 'femelle', src: crevette }
]
</script>

<style scoped>
.galerie-item {
  display: inline-block;
  width: 100%;
  break-inside: avoid;
  margin-bottom: 1rem;
}

.images-galerie img {
  max-width: 400px;
  width: 100%;
  height: auto;
  display: block;
  border-radius: 0.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
</style>